import React from "react";
import { cn } from "../../lib/utils";

const Select = React.forwardRef(({ className, children, ...props }, ref) => (
    <select
        ref={ref}
        className={cn(
            "flex h-[40px] w-full rounded-sm border border-[#bbb] bg-transparent px-3 text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-[#ededed] disabled:opacity-70",
            className
        )}
        {...props}
    >
        {children}
    </select>
));
Select.displayName = "Select";

export { Select };
